import Backbone from 'backbone';

import {HasOwnablePermissions, Owner, OwnerInfo} from 'auth/PermissionConstants';
import Enzymes, {Enzyme} from 'molbio/enzymes/backbone/Enzymes';

interface EnzymeListAttributes extends HasOwnablePermissions {
  name: string;
  created_at: string;
  description: string;
  owner: Owner;
  ownerInfo: OwnerInfo;
  owner_handle: string;
  members: Array<Enzyme>;
}

type EnzymeListServerResponse = Omit<EnzymeListAttributes, 'members'> & {
  members: Array<number>;
};

interface EnzymeList {
  get<K extends keyof EnzymeListAttributes>(key: K): EnzymeListAttributes[K];
}

class EnzymeList extends Backbone.Model {
  enzymes: Enzymes | undefined;

  // @ts-expect-error: Backbone types declare `url` as a property, but it actually works with methods too
  override url(): string {
    const base = '/1/api/enzyme-lists/';
    if (this.get('id') != null) {
      return base + this.get('id');
    } else {
      return base;
    }
  }

  override defaults(): Partial<EnzymeListAttributes> {
    return {
      name: '',
      description: '',
      members: [],
    };
  }

  override parse(response: EnzymeListServerResponse): EnzymeListAttributes {
    if (this.enzymes == null) {
      this.enzymes = Enzymes.getCommonEnzymes();
    }
    const {members} = response;
    return {
      ...response,
      members: Array.from(members).map((member) => this.enzymes!.get(member)),
    };
  }
}

export default EnzymeList;

export class EnzymeListCollection extends Backbone.Collection<EnzymeList> {
  static initClass(): void {
    this.prototype.model = EnzymeList;
  }
}
EnzymeListCollection.initClass();
